import { render, staticRenderFns } from "./images8.vue?vue&type=template&id=05dc6668&scoped=true"
import script from "./images8.vue?vue&type=script&lang=js"
export * from "./images8.vue?vue&type=script&lang=js"
import style0 from "./images8.vue?vue&type=style&index=0&id=05dc6668&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dc6668",
  null
  
)

export default component.exports